export const mapping: Record<string, string> = {
  id: 'd=>d.Id',
  name: 'd=>d.Name',
  address: 'd=>d.Address',
  automatAPIAddress: 'd=>d.automatAPIAddress',
}

const mapSortParam = (key: string) => mapping[key]

export default mapSortParam
